/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum indicating types of activities that can be logged for a housing application.
 */
export enum HousingApplicationActivityCode {
    CREATED = 'Created',
    SUBMITTED = 'Submitted',
    OFFER_SENT = 'OfferSent',
    OFFER_REJECTED = 'OfferRejected',
    OFFER_ACCEPTED = 'OfferAccepted',
    ADDED_TO_WAIT_LIST = 'AddedToWaitList',
    LOCATION_ACCEPTED = 'LocationAccepted',
    NO_OFFER = 'NoOffer',
    CREATED_FORM = 'CreatedForm',
    SCORE_CHANGED = 'ScoreChanged',
    STATUS_CHANGED = 'StatusChanged',
    EARLIEST_OCCUPANCY_DATE_CHANGED = 'EarliestOccupancyDateChanged',
    UPLOADED = 'Uploaded',
    OTHER = 'Other',
    NOTE_ADDED = 'NoteAdded',
    APPLICATION_CANCELED = 'ApplicationCanceled',
    MOVED_BACK_TO_REVIEW = 'MovedBackToReview',
    MOVED_BACK_TO_WAITLIST = 'MovedBackToWaitlist',
    UPDATED_FORM = 'UpdatedForm',
    ARCHIVE = 'Archive',
    UNARCHIVE = 'Unarchive',
    PRIMARY_CONTACT_CHANGED = 'PrimaryContactChanged',
}
